module.exports = __webpack_public_path__ + "static/media/avenir-lt-65-medium.45f795e2.ttf";